import styled from 'styled-components';
import { Message } from 'primereact/message';
import { colourPalette, hexToRGBA, padding } from 'styles/styles';

export const PMessageStyle = {
  Message: styled(Message)`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: ${padding.paddingMD};
    &.p-inline-message.p-inline-message-info {
      background-color: #e1eafc;
      color: ${colourPalette.neutral900};
    }
    &.p-inline-message.p-inline-message-warn {
      background-color: #fff4db;
      color: ${colourPalette.neutral900};
    }
    &.p-inline-message.p-inline-message-error {
      background-color: ${hexToRGBA(colourPalette.rose500, 0.05)};
      color: ${colourPalette.rose600};
    }
    &.p-inline-message.p-inline-message-success {
      background-color: #e3f2e6;
      color: ${colourPalette.neutral900};
    }
  `,
  IconWrapper: styled.div`
    position: relative;
    top: 2px;
    & > svg {
      margin-right: 12px;
    }
  `,
};
